












import Vue from 'vue'
export default Vue.extend({
	
	props: {
		value: {
			type: Boolean,
		},
	},

	computed: {
	},

	methods: {
		toggle() {
			this.$emit("input", !this.value);
		}
	}

})
